<script setup lang="ts">
import { ChevronRight } from 'lucide-vue-next'

import { ICON_STROKE } from '@/shared/ui'

/**
 * Drobčeková cesta nad `H1`.
 *
 * Posledná položka je aktuálna stránka a nie je odkaz — jej text nesie `H1`,
 * takže by sa inak zopakoval dvakrát.
 */
defineProps<{
	trailSk: readonly string[]
	currentSk: string
}>()
</script>

<template>
	<nav aria-label="Navigačná cesta">
		<ol class="flex flex-wrap items-center gap-1 text-xs text-fg-subtle">
			<li v-for="item in trailSk" :key="item" class="flex items-center gap-1">
				<span>{{ item }}</span>
				<ChevronRight :size="16" :stroke-width="ICON_STROKE" aria-hidden="true" />
			</li>
			<li aria-current="page" class="text-fg-muted">{{ currentSk }}</li>
		</ol>
	</nav>
</template>
